import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import shapeImg1 from "../../assets/img/banner/home12/dotted-shape.png";
import shapeImg2 from "../../assets/img/banner/home12/intro-box.png";
import bgImg from "../../assets/img/banner-1.jpg";

const bgStyle = {
  backgroundImage: `url(${bgImg})`,
  position: "relative",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundAttachment: "fixed", // Creates the scrolling/parallax effect
};

// Typing Animation Component
const TypingAnimation = () => {
  const staticText = "Building Software That ";
  const suffixes = [
    "Drives Growth",
    "Generates Revenue",
    "Drives Success"
  ];


  const [currentSuffixIndex, setCurrentSuffixIndex] = useState(0);
  const [displayedSuffix, setDisplayedSuffix] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [typingSpeed, setTypingSpeed] = useState(100);

  useEffect(() => {
    const currentSuffix = suffixes[currentSuffixIndex];

    const handleTyping = () => {
      if (!isDeleting) {
        // Typing forward
        if (displayedSuffix.length < currentSuffix.length) {
          setDisplayedSuffix(currentSuffix.substring(0, displayedSuffix.length + 1));
          setTypingSpeed(80 + Math.random() * 40); // Variable speed for natural feel
        } else {
          // Pause at end before deleting
          setTimeout(() => setIsDeleting(true), 2000);
        }
      } else {
        // Deleting backward
        if (displayedSuffix.length > 0) {
          setDisplayedSuffix(currentSuffix.substring(0, displayedSuffix.length - 1));
          setTypingSpeed(50);
        } else {
          // Move to next suffix
          setIsDeleting(false);
          setCurrentSuffixIndex((prevIndex) => (prevIndex + 1) % suffixes.length);
          setTypingSpeed(500); // Pause before starting new suffix
        }
      }
    };

    const timer = setTimeout(handleTyping, typingSpeed);
    return () => clearTimeout(timer);
  }, [displayedSuffix, isDeleting, currentSuffixIndex, typingSpeed]);

  return (
    <h1 className="sl-title" style={{ minHeight: "120px" }}>
      {staticText}
      <span style={{ color: "var(--brand-primary)" }}>{displayedSuffix}</span>
      <span
        className="typing-cursor"
        style={{
          borderRight: "3px solid var(--brand-primary)",
          animation: "blink 0.7s step-end infinite",
          marginLeft: "2px"
        }}
      >
      </span>
      <style>
        {`
          @keyframes blink {
            from, to { border-color: transparent; }
            50% { border-color: var(--brand-primary); }
          }
          
          @media (max-width: 991px) {
            .sl-title {
              min-height: 150px !important;
              font-size: 1.8rem !important;
            }
          }
          
          @media (max-width: 767px) {
            .sl-title {
              min-height: 180px !important;
              font-size: 1.5rem !important;
            }
          }
        `}
      </style>
    </h1>
  );
};

const BannerDefault = () => {
  return (
    <React.Fragment>
      {/* <!-- banner section start --> */}
      <div id="rs-banner" className="rs-banner style10" style={bgStyle}>
        {/* top gradient overlay */}
        <div
          className="banner-top-overlay"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "46%",
            background:
              "linear-gradient(180deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.35) 28%, rgba(0,0,0,0.15) 60%, rgba(0,0,0,0) 100%)",
            pointerEvents: "none",
            zIndex: 1,
          }}
        />
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="row">
            <div className="col-lg-6 pl-60 relative order-last">
              <div className="img-part">
                <div className="mil-illustration-1 mt-30 ">
                  <div className="mil-item mil-item-1">
                    <div className="mil-plus">
                      <div className="mil-hover-window">
                        <div className="mil-window-content">
                          <h5 className="mil-dark mil-mb-15">Dedicated Team</h5>
                          <div className="mil-divider mil-divider-left mil-mb-15"></div>
                          <p className="mil-text-sm">
                            Our team are always ready to service our clients
                            efficiently
                          </p>
                        </div>
                      </div>
                      <div className="mil-item-hover">
                        <div className="mil-plus-icon">+</div>
                        <h6 className="mil-light">Dedicated Team</h6>
                      </div>
                    </div>
                  </div>
                  <div className="mil-item mil-item-2">
                    <div className="mil-plus">
                      <div className="mil-hover-window">
                        <div className="mil-window-content">
                          <h5 className="mil-dark mil-mb-15">Infrastructure</h5>
                          <div className="mil-divider mil-divider-left mil-mb-15"></div>
                          <p className="mil-text-sm">
                            We have comfortable development infrastructur and
                            learning environment
                          </p>
                        </div>
                      </div>
                      <div className="mil-item-hover">
                        <div className="mil-plus-icon">+</div>
                        <h6 className="mil-light">Infrastructure</h6>
                      </div>
                    </div>
                  </div>
                  <div className="mil-item mil-item-3">
                    <div className="mil-plus">
                      <div className="mil-hover-window">
                        <div className="mil-window-content">
                          <h5 className="mil-dark mil-mb-15">Partners</h5>
                          <div className="mil-divider mil-divider-left mil-mb-15"></div>
                          <p className="mil-text-sm">
                            We have dedicated partners working with us to
                            service you.
                          </p>
                        </div>
                      </div>
                      <div className="mil-item-hover">
                        <div className="mil-plus-icon">+</div>
                        <h6 className="mil-light">Partners</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 pr-0">
              <div className="banner-content">
                <TypingAnimation />

                <div className="sl-sub-title mb-16">
                  Welcome to Syrol,
                  <span className="d-none d-md-inline">
                    {" "}
                    a software development and digital transformation company
                    delivering innovative software development and cybersecurity
                    solutions for web, mobile, and enterprise platforms.
                  </span>
                  Syrol delivers scalable software solutions that help
                  businesses launch faster, operate smarter, and grow stronger.
                </div>

                <div className="banner-btn ">
                  <Link className="readon green-banner ml-2" to="/consultation">
                    Request for a Free Consultation
                  </Link>

                  <Link
                    className="readon green-banner mt-5 ml-2"
                    to="/book-meeting"
                  >
                    <i className="fa fa-calendar"></i> &nbsp; Schedule a Meeting
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="banner-intro-box">
          <div className="shape-img">
            <img className="up-down-new" src={shapeImg1} alt="" />
          </div>
          <div className="intro-img">
            <img className="spine2" src={shapeImg2} alt="" />
          </div>
        </div>
      </div>
      {/* <!-- banner section end --> */}
    </React.Fragment>
  );
};

export default BannerDefault;
